import { render, staticRenderFns } from "./tail-info.vue?vue&type=template&id=29ade758&"
import script from "./tail-info.vue?vue&type=script&lang=js&"
export * from "./tail-info.vue?vue&type=script&lang=js&"
import style0 from "./tail-info.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports